<template>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
             :key="isSmallerScreen">
      <vs-tab v-if="$canAny(['view-user','create-user'])"  icon-pack="feather" icon="icon-log-in" :label="!isSmallerScreen ? 'Login Page' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <ManageLoginPage/>
        </div>
      </vs-tab>
    </vs-tabs>
  </template>
<script>
import ManageLoginPage from './tabs/ManageLoginPage.vue';
export default {
    name: 'ProductCommunications',
    components:{
        ManageLoginPage
    }
}

</script>